import { type Variants } from 'framer-motion';

export enum PopoverVariant {
    Hidden = 'hidden',
    Show = 'show',
}

export const popoverVariants: Variants = {
    [PopoverVariant.Hidden]: {
        opacity: 0,
        translateY: 0,
    },
    [PopoverVariant.Show]: {
        opacity: 1,
        translateY: 10,
    },
};
